<p-tabView *ngIf="censusData">
  <p-tabPanel header="{{ 'DATA_PORTAL.CENSUS.DETAIL.REPORT' | translate }}">
    <div class="ui-g">
      <div class="ui-g-12">
        <hr class="hr-text" [attr.data-content]="'DATA_PORTAL.CENSUS.DETAIL.CENSUS_DATA' | translate">
        <wsd-census-graphs
          [detailed]=true
          [entityLevel]="entityLevel"
          [entityId]="entityId"
          (sendDetailsData)="initShadowAndBeneficiariesData($event)"
        ></wsd-census-graphs>
      </div>
      <div class="ui-g-12" *ngIf="censusData.shadowCensusData?.id && entityLevel === searchEntityLevels.ORGANIZATION">
        <div *gsShowIfHasPermission="['NDP_ORGANIZATION_REPORT_SHADOW_CENSUS_READ']">
          <hr class="hr-text" [attr.data-content]="'DATA_PORTAL.CENSUS.DETAIL.SHADOW_CENSUS_DATA' | translate">
          <div class="ui-g">
            <div class="ui-g-3">
              <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.MALE' | translate }}</label>
              <div class="number-value">{{ shadowCensusHistoricalData.male }}</div>
              <wsd-delta
                [delta]="shadowCensusHistoricalData.maleDelta"
                [showPercentage]="false">
              </wsd-delta>
            </div>
            <div class="ui-g-3">
              <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.FEMALE' | translate }}</label>
              <div class="number-value">{{ shadowCensusHistoricalData.female }}</div>
              <wsd-delta
                [delta]="shadowCensusHistoricalData.femaleDelta"
                [showPercentage]="false">
              </wsd-delta>
            </div>
            <div class="ui-g-3">
              <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.OTHER' | translate }}</label>
              <div class="number-value">{{ shadowCensusHistoricalData.other }}</div>
              <wsd-delta
                [delta]="shadowCensusHistoricalData.otherDelta"
                [showPercentage]="false">
              </wsd-delta>
            </div>
            <div class="ui-g-3">
              <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.TOTAL' | translate }}</label>
              <div class="number-value">{{ shadowCensusHistoricalData.total }}</div>
              <wsd-delta
                [delta]="shadowCensusHistoricalData.totalDelta"
                [showPercentage]="false">
              </wsd-delta>
            </div>
          </div>
        </div>
      </div>
      <div class="ui-g-12 beneficiaries" *ngIf="beneficiariesData?.length > 0">
        <hr class="hr-text" [attr.data-content]="'DATA_PORTAL.CENSUS.DETAIL.BENEFICIARIES' | translate">
        <div class="ui-g m-b-30">
          <div class="ui-g-12">
            <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.TOTAL' | translate }}</label>
            <span class="number-value">{{ beneficiariesTotal }}</span>
          </div>
        </div>

        <div class="ui-g">
          <div class="ui-g-12 p-grid">
            <div class=" p-col-12 p-md-12 p-lg-7">
              <div *ngFor="let type of beneficiaryTypes$ | async">
                <label>{{ type }}</label>
                <div *ngFor="let beneficiary of beneficiariesData | beneficiaryType:type">
                  <div class="flex-container justify-space-between align-end m-b-15"
                       *ngIf="beneficiary.beneficiaryCategoryData?.active || beneficiary.total > 0">
                    <div class="flex-item">
                      {{ beneficiary.beneficiaryCategoryData?.beneficiaryCategoryCategory}}
                    </div>
                    <div class="flex-item grow">
                      <hr class="dotted">
                    </div>
                    <div class="flex-item shrink number-value">
                      {{beneficiary.total}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class=" p-col-12 p-md-12 p-lg-5">
              <p-chart
                type="pie"
                [data]="beneficiariesGraphData"
                [options]="beneficiaryGraphOptions"
                [plugins]="chartDataLabelsPlugin.initialize({ chartType:'pie', textColor:'black', textSize:8 })">
              </p-chart>
            </div>
          </div>
        </div>

      </div>
    </div>
  </p-tabPanel>
  <p-tabPanel
    header="{{ 'DATA_PORTAL.CENSUS.DETAIL.HISTORICAL_DATA' | translate }}"
    *ngIf="entityLevel === searchEntityLevels.ORGANIZATION || isFederation">
    <div class="ui-g">
      <div class="ui-g-3">
        <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.SELECT_YEAR' | translate }}</label>
        <p-dropdown
          [options]="yearOptions"
          [(ngModel)]="selectedYear"
          (onChange)="loadHistoryData($event)">
        </p-dropdown>
      </div>
    </div>

    <div class="ui-g" *ngIf="showNoDataForYearWarning && !isFederation">
      <div class="ui-g-12">
        <i class="fa fa-exclamation-circle fa-2x text-danger"></i>
        {{ 'DATA_PORTAL.CENSUS.DETAIL.NO_DATA_FOR_YEAR' | translate }}
      </div>
    </div>


    <div *ngIf="historyData">
      <div *ngFor="let groupType of availableAgeGroups">
        <div class="ui-g m-t-15">
          <div class="ui-g-4">
            <label class="title">{{ 'DATA_PORTAL.CENSUS.DETAIL.' + groupType | translate }}</label>
          </div>
          <div class="ui-g-2">
            <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.MALE' | translate }}</label>
          </div>
          <div class="ui-g-2">
            <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.FEMALE' | translate }}</label>
          </div>
          <div class="ui-g-2">
            <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.OTHER' | translate }}</label>
          </div>
          <div class="ui-g-2">
            <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.TOTAL' | translate }}</label>
          </div>
        </div>
        <div class="ui-g" *ngFor="let group of historyData.ageGroups | ageGroupType:groupType ">
          <div class="ui-g-4" *ngIf="groupType==='YOUNG'">
            <label class="main-group">{{ group.ageGroupData | ageGroupName }}</label>
            <label class="default-group" *ngIf="group.ageGroupData.defaultAgeGroup">
              {{ group.ageGroupData.defaultAgeGroup | ageGroupName }}
            </label>
          </div>
          <div class="ui-g-4" *ngIf="groupType==='ADULT'">
            <label class="main-group">{{ group.ageGroupData.ageGroupName }}</label>
            <label class="default-group" *ngIf="group.ageGroupData.defaultAgeGroup">
              {{ group.ageGroupData.defaultAgeGroup.ageGroupName }}
            </label>
          </div>
          <div class="ui-g-2">
            <input
              wsdPositiveNumbersOnly
              pInputText
              type="number"
              [disabled]="isHistoryDisabled"
              [(ngModel)]="group.male"
              (ngModelChange)="recalculate(group)">
          </div>
          <div class="ui-g-2">
            <input
              wsdPositiveNumbersOnly
              pInputText
              type="number"
              [disabled]="isHistoryDisabled"
              [(ngModel)]="group.female"
              (ngModelChange)="recalculate(group)">
          </div>
          <div class="ui-g-2">
            <input
              wsdPositiveNumbersOnly
              pInputText
              type="number"
              [disabled]="isHistoryDisabled"
              [(ngModel)]="group.other"
              (ngModelChange)="recalculate(group)">
          </div>
          <div class="ui-g-2">
            <input
              wsdPositiveNumbersOnly
              pInputText
              type="number"
              [(ngModel)]="group.total"
              [disabled]="!!(isHistoryDisabled || group.male || group.female || group.other)">
          </div>
        </div>
        <wsd-age-group-total
          [collection]="historyData.ageGroups | ageGroupType:groupType">
        </wsd-age-group-total>
      </div>
      <div class="ui-g">
        <div class="ui-g-12">
          <button
            *ngIf="!isHistoryDisabled"
            type="button" pButton
            [disabled]="isDisableToSave"
            [label]="'DATA_PORTAL.CENSUS.DETAIL.SAVE' | translate"
            (click)="saveHistoryData() ">
          </button>
        </div>
      </div>
    </div>

  </p-tabPanel>

  <p-tabPanel
    *ngIf="submitVisible && entityLevel === searchEntityLevels.ORGANIZATION"
    header="{{ 'DATA_PORTAL.CENSUS.DETAIL.SUBMIT_CENSUS' | translate }}">

    <div class="navigation-buttons">
      <button
        *gsShowIfHasPermission="['NDP_ORGANIZATION_CUSTOM_AGE_GROUP_READ']"
        pButton (click)="openModalWindow()"
        [label]="'DATA_PORTAL.CENSUS.DETAIL.EDIT_AGE_GROUPS' | translate">
      </button>
      <!--      <button-->
      <!--        pButton-->
      <!--        [label]="'DATA_PORTAL.CENSUS.DETAIL.EDIT_DATA' | translate">-->
      <!--      </button>-->
      <span *gsShowIfHasPermission="['NDP_ORGANIZATION_SHADOW_CENSUS_UPDATE']">
        <button
          pButton (click)="shadowVisible = true; censusData.savingShadowCensus=true" *ngIf="!shadowVisible"
          [label]="'DATA_PORTAL.CENSUS.DETAIL.ADD_SHADOW_CENSUS' | translate">
        </button>
        </span>
    </div>

    <div class="ui-g">
      <div class="ui-g-12">
        <hr
          class="hr-text"
          [attr.data-content]="'DATA_PORTAL.CENSUS.DETAIL.CENSUS_DATA_YEAR' | translate:{year: censusData?.censusYear || ''}">

        <div *ngIf="censusData?.censusPeriod">
          <div [ngSwitch]="censusData?.censusActive">
            <div *ngSwitchCase="true">
              <label class="text-center" *ngIf="censusData?.censusPeriod?.endDate">
                {{ 'DATA_PORTAL.CENSUS.DETAIL.CLOSES_ON' | translate:{date: censusData?.censusPeriod?.endDate | date} }}
              </label>
            </div>
            <div *ngSwitchCase="false">
              <label class="text-center" *ngIf="censusData?.censusPeriod?.startDate">
                {{ 'DATA_PORTAL.CENSUS.DETAIL.NEXT_STARTS' | translate:{date: censusData?.censusPeriod?.startDate | date} }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g">
      <div class="ui-g-4">
        <label class="title">{{ 'DATA_PORTAL.CENSUS.DETAIL.YOUNG' | translate }}</label>
      </div>
      <div class="ui-g-2">
        <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.MALE' | translate }}</label>
      </div>
      <div class="ui-g-2">
        <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.FEMALE' | translate }}</label>
      </div>
      <div class="ui-g-2">
        <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.OTHER' | translate }}</label>
      </div>
      <div class="ui-g-2">
        <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.TOTAL' | translate }}</label>
      </div>
    </div>

    <div *ngFor="let group of censusData?.ageGroups | ageGroupType:'YOUNG'">
      <div class="ui-g" *ngIf="group.ageGroupData.active">
        <div class="ui-g-4">
          <label class="main-group">{{ group.ageGroupData | ageGroupName }}</label>
          <label class="default-group" *ngIf="group.ageGroupData.defaultAgeGroup">
            {{ group.ageGroupData.defaultAgeGroup | ageGroupName }}
          </label>
        </div>
        <div class="ui-g-2">
          <input pInputText type="number"
                 wsdPositiveNumbersOnly
                 [disabled]="readOnly"
                 [(ngModel)]="group.male"
                 (ngModelChange)="recalculate(group)">
        </div>
        <div class="ui-g-2">
          <input pInputText type="number"
                 wsdPositiveNumbersOnly
                 [disabled]="readOnly"
                 [(ngModel)]="group.female"
                 (ngModelChange)="recalculate(group)">
        </div>
        <div class="ui-g-2">
          <input pInputText type="number"
                 wsdPositiveNumbersOnly
                 [disabled]="readOnly"
                 [(ngModel)]="group.other"
                 (ngModelChange)="recalculate(group)">
        </div>
        <div class="ui-g-2">
          <input
            pInputText
            wsdPositiveNumbersOnly
            type="number"
            [disabled]="readOnly || !!(group.male || group.female || group.other)"
            [(ngModel)]="group.total">
        </div>
      </div>
    </div>
    <wsd-age-group-total
      [collection]="censusData?.ageGroups | ageGroupType:'YOUNG'">
    </wsd-age-group-total>

    <div class="ui-g">
      <div class="ui-g-12">
        <label class="title">{{ 'DATA_PORTAL.CENSUS.DETAIL.ADULT' | translate }}</label>
      </div>
    </div>
    <div class="ui-g" *ngFor="let group of censusData?.ageGroups | ageGroupType:'ADULT'">
      <div class="ui-g-4">
        <label class="main-group">{{ group.ageGroupData.ageGroupName }}</label>
        <label class="default-group" *ngIf="group.ageGroupData.defaultAgeGroup">
          {{ group.ageGroupData.defaultAgeGroup.ageGroupName }}
        </label>
      </div>
      <div class="ui-g-2">
        <input pInputText type="number"
               wsdPositiveNumbersOnly
               [disabled]="readOnly"
               [(ngModel)]="group.male"
               (ngModelChange)="recalculate(group)">
      </div>
      <div class="ui-g-2">
        <input pInputText type="number"
               wsdPositiveNumbersOnly
               [disabled]="readOnly"
               [(ngModel)]="group.female"
               (ngModelChange)="recalculate(group)">
      </div>
      <div class="ui-g-2">
        <input pInputText type="number"
               wsdPositiveNumbersOnly
               [disabled]="readOnly"
               [(ngModel)]="group.other"
               (ngModelChange)="recalculate(group)">
      </div>
      <div class="ui-g-2">
        <input
          pInputText
          wsdPositiveNumbersOnly
          type="number"
          [disabled]="readOnly || !!(group.male || group.female || group.other)"
          [(ngModel)]="group.total">
      </div>
    </div>
    <wsd-age-group-total
      [collection]="censusData?.ageGroups | ageGroupType:'ADULT'">
    </wsd-age-group-total>

    <div *ngIf="censusData && shadowVisible">
      <hr class="hr-text" [attr.data-content]="'DATA_PORTAL.CENSUS.DETAIL.SHADOW_CENSUS_DATA' | translate">
      <div class="ui-g">
        <div class="ui-g-3">
          <label for="male">{{ 'DATA_PORTAL.CENSUS.DETAIL.MALE' | translate }}</label>
          <input pInputText id="male"
                 wsdPositiveNumbersOnly
                 type="number"
                 [disabled]="readOnly"
                 [(ngModel)]="shadowCensus.male"
                 (ngModelChange)="recalculate(shadowCensus)">
        </div>
        <div class="ui-g-3">
          <label for="female">{{ 'DATA_PORTAL.CENSUS.DETAIL.FEMALE' | translate }}</label>
          <input pInputText id="female"
                 wsdPositiveNumbersOnly
                 type="number"
                 [disabled]="readOnly"
                 [(ngModel)]="shadowCensus.female"
                 (ngModelChange)="recalculate(shadowCensus)">
        </div>
        <div class="ui-g-3">
          <label for="other">{{ 'DATA_PORTAL.CENSUS.DETAIL.OTHER' | translate }}</label>
          <input pInputText id="other"
                 wsdPositiveNumbersOnly
                 type="number"
                 [disabled]="readOnly"
                 [(ngModel)]="shadowCensus.other"
                 (ngModelChange)="recalculate(shadowCensus)">
        </div>
        <div class="ui-g-3">
          <label for="total">{{ 'DATA_PORTAL.CENSUS.DETAIL.TOTAL' | translate }}</label>
          <input pInputText id="total"
                 wsdPositiveNumbersOnly
                 type="number"
                 [disabled]="readOnly || !!(shadowCensus.male || shadowCensus.female || shadowCensus.other)"
                 [(ngModel)]="shadowCensus.total">
        </div>
      </div>
    </div>


    <hr class="hr-text" [attr.data-content]="'DATA_PORTAL.CENSUS.DETAIL.BENEFICIARIES' | translate">

    <wsd-beneficiaries
      [readOnly]="readOnly"
      [census]="censusData">
    </wsd-beneficiaries>

    <button
      type="button" pButton
      *ngIf="!readOnly"
      [disabled]="isDisableToSave"
      [label]="'DATA_PORTAL.CENSUS.DETAIL.SAVE' | translate"
      (click)="saveCensus()">
    </button>
  </p-tabPanel>
  <p-tabPanel
    header="{{ 'DATA_PORTAL.CENSUS.DETAIL.EXPORT_DATA' | translate }}">
    <wsd-census-export
      [censusData]="censusData"
      [entityId]="entityId"
      [entityLevel]="entityLevel"
      [lastCensusYear]="lastCensusYear"
      [isNSO]="isNSO"
      [isFederation]="isFederation">
    </wsd-census-export>
  </p-tabPanel>
</p-tabView>

<wsd-add-custom-age-groups
  [organizationId]="entityId"
  (onSave)="onCustomAgeGroupSave($event)">
</wsd-add-custom-age-groups>
